import { useState } from "react";
import { toast } from "react-toastify";
import {
  apiGetSubGroupById,
  apiGetSubGrupos,
  apiSaveSubGroup,
} from "../api/subGruposApi";

export const useSubGroup = () => {
  const [subgroups, setSubGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedSubGroup, setSelectedSubGroup] = useState(null);
  const [groupSelected, setGroupSelected] = useState("");

  const [form, setForm] = useState({
    id: "",
    codigo: "",
    descripcion: "",
    idgrupo: "",
    orden: "",
    visible: 0,
    estado: 1,
    menu: 0,
    id_empresa: 0,
  });


  const loadSubGroup = async (idgrupo) => {
    setGroupSelected(idgrupo);
    try {
      if (!idgrupo) {
        setSubGroups([]);
        return;
      }

      const res = await apiGetSubGrupos('',idgrupo);
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);
      setSubGroups(list);
    } catch {
      toast.error("fn loadSubGroup: Error cargando subgrupos");
    }
  };


  const loadSubGroupById = async (id) => {
    try {
      const res = await apiGetSubGroupById(id);

      if (!res.success) {
        toast.error("Ruta no encontrada");
        return;
      }

      const subg = res.data;
      setForm({
        id: subg.id,
        codigo: subg.codigo || "",
        descripcion: subg.descripcion || "",
        idgrupo: subg.idGrupo || "",
        orden: subg.orden || 0,
        visible: subg.visible || 0,
        estado: subg.estado,
        menu: subg.menu || 0,
        id_empresa: subg.id_empresa || 0,
      });
    } catch {
      toast.error("fn loadSubGroupById: Error consultando grupo");
    }
  };

  const handleSelectSubGroups = (id) => {
    setSelectedSubGroup(id);
    loadSubGroupById(id);
  };

  // ---- New  ----
  const handleNew = () => {
    setSelectedSubGroup(null);
    setForm({
      id: "",
      codigo: "",
      descripcion: "",
      idgrupo: "",
      orden: "",
      visible: 0,
      estado: 1,
      menu: 0,
      id_empresa: 0,
    });
  };

  // ---- Save  ----
  const saveSubGroups = async () => {
    if (!form.codigo) {
      toast.error("El codigo no puede ser vacio");
      return;
    }
    if (!form.descripcion) {
      toast.error("La descripcion no puede ser vacio");
      return;
    }

    try {
      const res = await apiSaveSubGroup(form);

      if (!res.success) {
        toast.error(res.message || "Error guardando ruta");
        return;
      }

      toast.success(res.message);
      loadSubGroup(form.idgrupo);
      handleNew();
    } catch {
      toast.error("fn saveSubGroups: Error guardando ruta");
    }
  };

  return {
    subgroups,
    search,
    setSearch,
    selectedSubGroup,
    groupSelected,
    form,
    setForm,
    handleNew,
    handleSelectSubGroups,
    saveSubGroups,
    loadSubGroup,
  };
};
